import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, accessToken, loading } = useUser();

  if (loading) return null;
  if (!user || !accessToken) return <Navigate to="/login" replace />;

  return <>{children}</>;
};

export default PrivateRoute; 